import React from "react";
import CustomInput from "components/CustomInput/CustomInput";
import DatePicker from "components/DatePicker";
import CustomRangeSlider from "components/CustomRangeSlider";
import { faBuilding, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const styles = {
  basicInfoContainer: {
    marginTop: "20px",
  },
  fullWidth: {
    width: "100%",
  },
  errors: {
    left: "2px",
    bottom: "-22px",
    position: "absolute",
    fontSize: "12px",
    fontWeight: "400",
    userSelect: "none",
    color: "red",
  },
  profileTextArea: {
    width: "100%",
    minHeight: "80px",
    marginTop: "0px",
    marginBottom: "0px",
    height: "109px",
    maxHeight: "110px",
  },
};

export default ({ editable, formik }) => {
  const classes = styles;

  return (
    <>
      <div style={classes.basicInfoContainer} className="row">
        <div className="col-md-6 col-sm-6 col-lg-6">
          <label>Company Name</label>
          <CustomInput
            startIcon={
              <FontAwesomeIcon icon={faBuilding} className="formIcon" />
            }
            id={"company-name"}
            disabled={!editable}
            inputProps={{
              type: "text",
              placeholder: "Company Name",
              ...formik.getFieldProps("company_name"),
              error: formik.errors.company_name,
            }}
            inputClass="user-profile-inputs"
          />
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6 company-joining-date">
          <label>Company Joining Date</label>
          <DatePicker
            startIcon={
              <FontAwesomeIcon icon={faCalendar} className="formIcon" />
            }
            placeHolder="Company Joining Date"
            inputClass="user-profile-inputs"
            value={formik.values.company_joining_date}
            inputProps={{
              error:
                !!formik.errors.company_joining_date &&
                !!formik.errors.company_joining_date &&
                formik.errors.company_joining_date,
            }}
            onChange={(value) => {
              formik.setFieldValue("company_joining_date", value);
            }}
            disabled={!editable}
            maxDate={new Date()}
          />
        </div>
        <div
          className="col-md-6 col-sm-6 col-lg-6"
          style={{ padding: "15px 25px" }}
        >
          <label>
            Percentage of time Remote ({`${formik.values.per_of_time_remote}`}
            -100%)
          </label>
          <div className="formGroup">
            <CustomRangeSlider
              minValue={0}
              maxValue={100}
              steps={10}
              disabled={!editable}
              className="workRange"
              trackStyle={{ backgroundColor: "rgb(255, 161, 0)" }}
              dotStyle={{ borderColor: "rgb(255, 161, 0)" }}
              activeDotStyle={{
                borderColor: "rgb(255, 161, 0)",
                width: "10px",
                height: "10px",
                bottom: "-3px",
                backgroundColor: "rgb(255, 161, 0)",
              }}
              handleStyle={{
                border: "solid 2px rgb(255, 161, 0)",
                backgroundColor: "rgb(255, 161, 0)",
              }}
              marks={{
                0: 0,
                10: 10,
                20: 20,
                30: 30,
                40: 40,
                50: 50,
                60: 60,
                70: 70,
                80: 80,
                90: 90,
                100: 100,
              }}
              style={{ height: "40px" }}
              value={formik.values.per_of_time_remote}
              onChange={(value) => {
                formik.setFieldValue("per_of_time_remote", value);
              }}
            />
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6 col-lg-6"
          style={{ padding: "15px 25px" }}
        >
          <label>
            Percentage of time in Office (
            {`${formik.values.per_of_time_office}`}-100%)
          </label>
          <div className="formGroup">
            <CustomRangeSlider
              minValue={0}
              maxValue={100}
              steps={10}
              disabled={!editable}
              className="workRange"
              trackStyle={{ backgroundColor: "rgb(255, 161, 0)" }}
              dotStyle={{ borderColor: "rgb(255, 161, 0)" }}
              activeDotStyle={{
                borderColor: "rgb(255, 161, 0)",
                width: "10px",
                height: "10px",
                bottom: "-3px",
                backgroundColor: "rgb(255, 161, 0)",
              }}
              handleStyle={{
                border: "solid 2px rgb(255, 161, 0)",
                backgroundColor: "rgb(255, 161, 0)",
              }}
              marks={{
                0: 0,
                10: 10,
                20: 20,
                30: 30,
                40: 40,
                50: 50,
                60: 60,
                70: 70,
                80: 80,
                90: 90,
                100: 100,
              }}
              style={{ height: "40px" }}
              value={formik.values.per_of_time_office}
              onChange={(value) => {
                formik.setFieldValue("per_of_time_office", value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
